<template>
  <div class="framework">
    <HomeHead 
      @show-login="showLoginModal" 
      @show-register="showRegisterModal" 
      :class="{ 'mobile-hidden-view': ['Chat', 'Channel'].includes($route.name) }"
    ></HomeHead>
    <HomeBody @show-login="showLoginModal"></HomeBody>
    <!-- 全局页脚（PC端显示，移动端隐藏） -->
    <HomeFoot class="global-footer" />
    
    <!-- 公告模态框 -->
    <AnnouncementModal 
      :visible="showAnnouncement" 
      @close="closeAnnouncement"
    />

    <!-- 全局下载渠道选择弹窗 -->
    <DownloadModal
      v-model:visible="downloadModalVisible"
      :buttons="downloadButtons"
      @select="handleGlobalDownload"
    />

    <!-- 全局历史版本弹窗 -->
    <HistoryModal
      v-model:visible="historyModalVisible"
      :history="historyList"
      :loading="isHistoryLoading"
      @download="handleGlobalHistoryDownload"
    />

    <!-- 全局云语托管文件选择弹窗 -->
    <CloudDownloadModal
      v-model:visible="cloudDownloadModalVisible"
      :app-id="cloudDownloadAppId"
      @download="handleGlobalCloudDownload"
    />

    <!-- 问题反馈弹窗 -->
    <FeedbackModal
      v-model:visible="feedbackModalVisible"
    />

    <!-- 友情链接申请弹窗 -->
    <FriendLinkApplyModal
      v-model:visible="friendlinkApplyModalVisible"
    />

    <!-- 条目投稿弹窗 -->
    <SoftwareSubmissionModal
      v-model:visible="submissionModalVisible"
    />

    <!-- 赞赏支持弹窗 -->
    <DonationModal
      v-model:visible="donationModalVisible"
    />

    <!-- 忘记密码弹窗 -->
    <ForgotPasswordModal
      v-model:visible="forgotPasswordModalVisible"
      
      />

    <AvatarModal 
      v-model:visible="avatarModalVisible"
      :username="avatarModalUsername"
      @success="handleAvatarSuccess"
    />

    <FollowModal
      v-model:visible="followModalVisible"
      :type="followModalType"
      :users="followModalUsers"
      :loading="followModalLoading"
      :currentPage="followModalPage"
      :pageSize="followModalPageSize"
      :total="followModalTotal"
      @page-change="handleFollowPageChange"
      @unfollow="handleUnfollow"
      @close="handleFollowModalClose"
    />

    <!-- 2FA 对话框 -->
    <TwofaDialog
      v-model:visible="twofaDialogVisible"
      :secret="twofaDialogSecret"
      :otpauth="twofaDialogOtpauth"
      @confirm="handleTwofaConfirm"
    />
    
    <!-- 登录模态框 -->
    <LoginModal 
      :visible="showLogin" 
      @close="closeLoginModal" 
      @switch-to-register="switchToRegister"
    />
    
    <!-- 注册模态框 -->
    <RegisterModal 
      :visible="showRegister" 
      @close="closeRegisterModal" 
      @switch-to-login="switchToLogin"
    />

    <!-- 个性化装扮商城弹窗 -->
    <StoreModal />

    <RejectModal />

    <AiResultModal />
    
    <ReleaseNoteModal />
    
    <!-- 全局右键菜单 -->
    <div 
      v-show="contextMenuVisible" 
      ref="contextMenu"
      class="global-context-menu"
      :class="{ 'is-mobile-menu': isMobileDevice }"
      :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }"
      @click.stop
      @touchstart.stop
    >
      <div class="context-menu-item" @click="selectAllText" title="全选">
        <i class="fa-solid fa-file-circle-check"></i>
        <span class="menu-item-text">全选</span>
      </div>
      <div class="context-menu-item" @click="copySelectedText" title="复制">
        <i class="fa-solid fa-copy"></i>
        <span class="menu-item-text">复制</span>
      </div>
      <div class="context-menu-item" @click="pasteText" title="粘贴">
        <i class="fa-solid fa-paste"></i>
        <span class="menu-item-text">粘贴</span>
      </div>
      <div v-if="contextMenuTargetAppId" class="context-menu-item" @click="cancelFavoriteByContext" title="取消收藏">
        <i class="fa-regular fa-heart"></i>
        <span class="menu-item-text">取消收藏</span>
      </div>
      <div v-if="canAddFriendFlag" class="context-menu-item" @click="viewTargetUser" title="查看用户">
        <i class="fa-solid fa-user"></i>
        <span class="menu-item-text">查看用户</span>
      </div>
      <div v-if="contextMenuTargetPeerId" class="context-menu-item" @click="toggleContextDnd" :title="isContextDnd ? '关闭免打扰' : '开启免打扰'">
        <i class="fa-regular fa-bell-slash"></i>
        <span class="menu-item-text">{{ isContextDnd ? '关闭免打扰' : '开启免打扰' }}</span>
      </div>
      <div v-if="contextMenuTargetPeerId" class="context-menu-item" @click="toggleContextBlacklist" :title="isContextBlacklisted ? '取消拉黑' : '拉黑'">
        <i class="fa-solid fa-user-slash"></i>
        <span class="menu-item-text">{{ isContextBlacklisted ? '取消拉黑' : '拉黑' }}</span>
      </div>
      <div v-if="contextMenuTargetPeerId" class="context-menu-item" @click="openEditRemarkDialog" title="修改备注">
        <i class="fa-solid fa-pen"></i>
        <span class="menu-item-text">修改备注</span>
      </div>
      <div v-if="canAddFriendFlag" class="context-menu-item" @click="openReportDialog" title="举报用户">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span class="menu-item-text">举报用户</span>
      </div>
      <div v-if="contextTargetMessage" class="context-menu-item" @click="recallGlobalMessage" title="撤回消息">
        <i class="fa-solid fa-rotate-left"></i>
        撤回
      </div>
    </div>
    
    <!-- 图片查看器 -->
    <ImageViewer 
      :visible="imageViewerVisible" 
      :imageSrc="currentImageSrc" 
      :imageAlt="currentImageAlt" 
      @close="closeImageViewer" 
    />
    
    <!-- 修改备注弹窗 -->
    <ModifyAliasModal
      v-model:visible="showModifyAliasModal"
      :initial-value="currentAlias"
      :loading="isModifyingAlias"
      @submit="submitModifyAlias"
    />
    
    <!-- 图片悬停提示 -->
    <div 
      v-if="imageTooltipVisible" 
      class="image-tooltip" 
      :style="{ left: imageTooltipX + 'px', top: imageTooltipY + 'px' }"
    >
      双击查看图片
    </div>

    <!-- 全局返回顶部按钮 -->
    <BackToTop v-if="!['Chat', 'Channel'].includes($route.name)" :threshold="120" />

    <!-- 右上角通知 -->


    <!-- 添加好友对话框 -->


    <!-- 统一举报对话框 -->
    <ReportUserModal
      v-model:visible="showReportModal"
      :loading="isReporting"
      @submit="submitReportFromModal"
    />

    <!-- 全局分享对话框 -->
    <ShareModal
      v-model:visible="shareModalVisible"
      :share-text="shareText"
    />

    <!-- 自定义下载协议弹窗 -->
    <AgreementModal
      v-model:visible="agreementModalVisible"
      @confirm="handleAgreementConfirm"
    />

    <!-- 自定义提取码弹窗 -->
    <CloudCodeModal
      v-model:visible="cloudCodeModalVisible"
      :code="currentCloudCode"
      @confirm="handleCloudCodeConfirm"
    />

    <!-- Github加速下载弹窗 -->
    <GithubDownloadModal
      v-model:visible="githubDownloadModalVisible"
      :github-url="githubDownloadUrl"
      :app-id="githubAppId"
      :initial-file="githubInitialFile"
    />

    <!-- 催更/检查更新弹窗 -->
    <UrgeUpdateModal
      v-model:visible="urgeUpdateDialogVisible"
      :app-id="urgeUpdateAppId"
      :loading="isUrgingUpdate"
      @submit="submitUrgeUpdateFromModal"
    />

    <!-- 自定义 UI 组件 -->
    <Toast />
    <MessageBox />
    <LoadingOverlay />

    <ServerMaintenanceOverlay :visible="serverDown" />

    <SecurityBlockOverlay :visible="securityBlocked" />

    <!-- 站外跳转安全提示弹窗 -->
    <LinkWarningModal
      v-model:visible="linkWarningVisible"
      :url="linkWarningUrl"
      @confirm="handleLinkWarningConfirm"
    />

    <!-- 🧪 临时 UI 测试实验室 (测试完成后可移除) -->
    <div class="ui-test-lab" v-if="showTestLab">
      <div class="test-lab-header">
        <span>🧪 UI 实验室</span>
        <button @click="showTestLab = false"><i class="fa-solid fa-times"></i></button>
      </div>
      <div class="test-buttons">
        <div class="test-lab-divider">核心反馈</div>
        <button @click="testToast('success'); showTestLab = false">成功 Toast</button>
        <button @click="testToast('error'); showTestLab = false">长文 Toast</button>
        <button @click="testMessageBox('alert'); showTestLab = false">Alert 警告</button>
        <button @click="testMessageBox('confirm'); showTestLab = false">Confirm 确认</button>
        <button @click="testMessageBox('prompt'); showTestLab = false">Prompt 输入</button>
        <button @click="testLoading(); showTestLab = false">Loading</button>

        <div class="test-lab-divider">账号与资料</div>
        <button @click="showLogin = true; showTestLab = false">登录弹窗</button>
        <button @click="showRegister = true; showTestLab = false">注册弹窗</button>
        <button @click="testAvatarModal(); showTestLab = false">修改头像</button>
        <button @click="testTwofaModal(); showTestLab = false">2FA 验证</button>
        <button @click="forgotPasswordModalVisible = true; showTestLab = false">忘记密码</button>
        <button @click="testFollowModal(); showTestLab = false">关注/粉丝</button>
        <button @click="showModifyAliasModal = true; currentAlias = 'Henvei'; showTestLab = false">修改备注</button>

        <div class="test-lab-divider">业务流程</div>
        <button @click="showAnnouncement = true; showTestLab = false">全站公告</button>
        <button @click="testDownloadModal(); showTestLab = false">下载渠道</button>
        <button @click="testHistoryModal(); showTestLab = false">历史版本</button>
        <button @click="feedbackModalVisible = true; showTestLab = false">意见反馈</button>
        <button @click="submissionModalVisible = true; showTestLab = false">条目投稿</button>
        <button @click="shareModalVisible = true; shareText = '测试分享: https://4yshop.top'; showTestLab = false">分享对话框</button>
        <button @click="urgeUpdateDialogVisible = true; urgeUpdateAppId = 1; showTestLab = false">催更对话框</button>
        <button @click="agreementModalVisible = true; showTestLab = false">下载协议</button>
        <button @click="cloudCodeModalVisible = true; currentCloudCode = '8888'; showTestLab = false">提取码</button>
        <button @click="githubDownloadModalVisible = true; githubDownloadUrl = 'https://github.com/henvei/test'; showTestLab = false">Github加速</button>

        <div class="test-lab-divider">管理审计</div>
        <button @click="testRejectModal(); showTestLab = false">驳回申请</button>
        <button @click="testAiResultModal(); showTestLab = false">AI审核结果</button>
        <button @click="showReportModal = true; showTestLab = false">用户举报</button>
      </div>
    </div>
    <button class="ui-test-trigger" @click="showTestLab = !showTestLab" v-if="!showTestLab" v-show="false">
      🧪 测试 UI
    </button>
  </div>
</template>

<script>
import HomeHead from '@/components/HomeHead.vue';
import HomeBody from '@/components/HomeBody.vue';
import HomeFoot from '@/components/HomeFoot.vue';
import AnnouncementModal from '@/components/AnnouncementModal.vue';
import DownloadModal from '@/components/DownloadModal.vue';
import HistoryModal from '@/components/HistoryModal.vue';
import CloudDownloadModal from '@/components/CloudDownloadModal.vue';
import FeedbackModal from '@/components/FeedbackModal.vue';
import FriendLinkApplyModal from '@/components/FriendLinkApplyModal.vue';
import SoftwareSubmissionModal from '@/components/SoftwareSubmissionModal.vue';
import DonationModal from '@/components/DonationModal.vue';
import ForgotPasswordModal from '@/components/ForgotPasswordModal.vue';
import TwofaDialog from '@/components/TwofaDialog.vue';
import AvatarModal from '@/components/AvatarModal.vue';
import FollowModal from '@/components/FollowModal.vue';
import LoginModal from '@/views/Login.vue';
import RegisterModal from '@/views/Register.vue';
import ImageViewer from '@/components/ImageViewer.vue';
import BackToTop from '@/components/BackToTop.vue';
import StoreModal from '@/components/StoreModal.vue';

import ShareModal from '@/components/ShareModal.vue';
import UrgeUpdateModal from '@/components/UrgeUpdateModal.vue';
import AgreementModal from '@/components/AgreementModal.vue';
import CloudCodeModal from '@/components/CloudCodeModal.vue';
import GithubDownloadModal from '@/components/GithubDownloadModal.vue';
import ReleaseNoteModal from '@/components/modals/ReleaseNoteModal.vue';
import ModifyAliasModal from '@/components/ModifyAliasModal.vue';
import ReportUserModal from '@/components/ReportUserModal.vue';
import RejectModal from '@/components/modals/RejectModal.vue';
import AiResultModal from '@/components/modals/AiResultModal.vue';
import Toast from '@/components/ui/Toast.vue';
import MessageBox from '@/components/ui/MessageBox.vue';
import LoadingOverlay from '@/components/ui/LoadingOverlay.vue';
import ServerMaintenanceOverlay from '@/components/ServerMaintenanceOverlay.vue';
import SecurityBlockOverlay from '@/components/SecurityBlockOverlay.vue';
import LinkWarningModal from '@/components/LinkWarningModal.vue';
import authService from '@/services/authService';
import { startHealthCheck, stopHealthCheck, onServerStatusChange } from '@/services/serverHealth';
import { message, messageBox, loading, notification } from '@/utils/ui-service'
import { h } from 'vue';
import websocketService from '@/services/websocketService';
import prefsService from '@/services/prefsService';
import userService from '@/services/friendsService';
import followService from '@/services/followService';
import eventBus from '@/utils/eventBus';
import serverUrl, { assetsUrl, avatarUrl as baseAvatarUrl } from '@/assets/BaseServerUrl.js';
import axios from 'axios';

export default {
    data() {
        return {
            wallpaperTimer: null,
            wallpaperPrefs: null,
            wallpaperPrefsLoaded: false,
            serverDown: false,
            securityBlocked: false,
            backgroundImage: '@/assets/img/Abstract_Landscape_1.webp',
            showAnnouncement: false,
            showLogin: false,
            showRegister: false,
            lastCopiedContent: '', // 记录上次复制的内容
            isInternalCopy: false, // 内部复制标记位，防止二次弹窗
            contextMenuTarget: null, // 保存右键时的目标DOM元素
            isMobileDevice: false, // 移动端设备标记
            isSelectingAll: false, // 正在全选标记位，防止全选时菜单位置漂移
            // 全局右键菜单相关
            contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedText: '',
      lastFocusedElement: null, // 保存右键时的焦点元素
      // 聊天卡片目标
      contextMenuTargetPeerId: '',
      isContextDnd: false,
      isContextBlacklisted: false,
      contextTargetRemark: '',
      contextTargetUserId: '',
      contextTargetUsername: '',
      // 图片查看器相关
      imageViewerVisible: false,
      currentImageSrc: '',
      currentImageAlt: '',
      // 图片悬停提示
      imageTooltipVisible: false,
      imageTooltipX: 0,
      imageTooltipY: 0,
      // 防重复通知：记录最近一次弹窗的消息键与时间
      lastNotifiedKey: '',
      lastNotifiedTime: 0,
      hoveredImage: null,
      imageTooltipTimer: null, // 悬停延迟定时器
      // 用户与偏好
      userId: null,
      userPrefs: { acceptFriendRequests: true, blacklist: [], dndPeers: {}, globalDnd: false, remarks: {} },
      friendMap: {},
      // 举报相关
      showReportModal: false,
      isReporting: false,
      reportTargetId: null,
      reportTargetUsername: '',
      
      // 修改备注弹窗
      showModifyAliasModal: false,
      currentAlias: '',
      isModifyingAlias: false,
      // 右键菜单：收藏上下文
      contextMenuTargetAppId: '',
      // 右键菜单：消息撤回上下文
      contextTargetMessage: null,
      
      // 全局下载与历史弹窗状态
      downloadModalVisible: false,
      downloadButtons: [],
      currentDownloadCallback: null,
      historyModalVisible: false,
      historyList: [],
      isHistoryLoading: false,
      currentHistoryDownloadCallback: null,
      
      cloudDownloadModalVisible: false,
      cloudDownloadAppId: null,
      currentCloudDownloadCallback: null,
      
      // 反馈与投稿与友链申请
      feedbackModalVisible: false,
      submissionModalVisible: false,
      donationModalVisible: false,
      friendlinkApplyModalVisible: false,
      
      // 忘记密码
      forgotPasswordModalVisible: false,

      // Avatar/Follow Modals
      avatarModalVisible: false,
      avatarModalUsername: '',
      
      followModalVisible: false,
      followModalType: 'following',
      followModalUsers: [],
      followModalLoading: false,
      followModalPage: 1,
      followModalPageSize: 20,
      followModalTotal: 0,
      currentFollowTargetUid: null,

      twofaDialogVisible: false,
      twofaDialogSecret: '',
      twofaDialogOtpauth: '',

      // 迁移自 AppDetails.vue 的全局状态
      shareModalVisible: false,
      shareText: '',
      agreementModalVisible: false,
      agreementConfirmCallback: null,
      cloudCodeModalVisible: false,
      currentCloudCode: '',
      cloudCodeConfirmCallback: null,
      githubDownloadModalVisible: false,
      githubDownloadUrl: '',
      githubAppId: null,
      githubInitialFile: null,
      urgeUpdateDialogVisible: false,
      urgeUpdateAppId: null,
      isUrgingUpdate: false,
      showTestLab: false,
      canAddFriendFlag: false,
      
      // 站外跳转安全提示相关
      linkWarningVisible: false,
      linkWarningUrl: ''
        }
    },
    components: {
        HomeHead,
        HomeBody,
        HomeFoot,
        AnnouncementModal,
        DownloadModal,
        HistoryModal,
        CloudDownloadModal,
        FeedbackModal,
        FriendLinkApplyModal,
        SoftwareSubmissionModal,
        DonationModal,
        ForgotPasswordModal,
        TwofaDialog,
        AvatarModal,
        FollowModal,
        LoginModal,
        RegisterModal,
        StoreModal,
        ReleaseNoteModal,
        ModifyAliasModal,
        ShareModal,
        UrgeUpdateModal,
        AgreementModal,
        CloudCodeModal,
        GithubDownloadModal,
        ReportUserModal,
        RejectModal,
        AiResultModal,
        Toast,
        MessageBox,
        LoadingOverlay,
        ServerMaintenanceOverlay,
        SecurityBlockOverlay,
        ImageViewer,
        BackToTop,
        LinkWarningModal
    },
    methods: {
        isSafeInternalUrl(rawUrl) {
            if (!rawUrl || typeof rawUrl !== 'string') return true;
            const trimmed = rawUrl.trim();
            // 相对路径、锚点、特定内部协议（javascript、blob、data、mailto 等）视为安全站内或系统行为
            if (trimmed.startsWith('/') || trimmed.startsWith('#') || 
                trimmed.startsWith('javascript:') || trimmed.startsWith('blob:') || 
                trimmed.startsWith('data:') || trimmed.startsWith('mailto:') || trimmed.startsWith('tel:')) {
                return true;
            }
            try {
                const urlObj = new URL(trimmed, window.location.href);
                const targetHost = urlObj.hostname.toLowerCase();
                const currentHost = window.location.hostname.toLowerCase();

                // 规则：当前域名、4yshop.top 以及 *.4yshop.top（泛域名）均为本站安全资产，无需拦截
                return targetHost === currentHost ||
                       targetHost === '4yshop.top' ||
                       targetHost.endsWith('.4yshop.top');
            } catch (e) {
                return true;
            }
        },
        openSafeUrl(rawUrl, target = '_blank') {
            if (!rawUrl) return;
            let url = String(rawUrl).trim();
            if (!/^https?:\/\//i.test(url) && !url.startsWith('/') && !url.startsWith('blob:')) {
                url = 'https://' + url;
            }
            const isSafe = (this && typeof this.isSafeInternalUrl === 'function')
                ? this.isSafeInternalUrl(url)
                : false;
            if (isSafe) {
                const opener = window._originalOpen || window.open;
                opener.call(window, url, target, 'noopener,noreferrer');
            } else {
                if (this && typeof this.linkWarningVisible !== 'undefined') {
                    this.linkWarningUrl = url;
                    this.linkWarningVisible = true;
                }
            }
        },
        setupWindowOpenProxy() {
            if (!window._originalOpen) {
                window._originalOpen = window.open;
            }
            const self = this;
            window.open = function(url, ...args) {
                if (!url || typeof url !== 'string') {
                    return window._originalOpen.apply(window, [url, ...args]);
                }
                const trimmed = url.trim();
                if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
                    if (!self.isSafeInternalUrl(trimmed)) {
                        self.linkWarningUrl = trimmed;
                        self.linkWarningVisible = true;
                        return null;
                    }
                }
                return window._originalOpen.call(window, url, ...args);
            };
        },
        restoreWindowOpenProxy() {
            if (window._originalOpen) {
                window.open = window._originalOpen;
            }
            if (window.$openSafeUrl) {
                delete window.$openSafeUrl;
            }
        },
        handleGlobalLinkClick(event) {
            const anchor = event.target.closest('a');
            if (!anchor) return;

            // 具有 download 属性或者声明了免拦截属性的，直接放行
            if (anchor.hasAttribute('download') || anchor.hasAttribute('data-no-warning')) return;

            const href = anchor.getAttribute('href');
            if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

            if (href.startsWith('http://') || href.startsWith('https://')) {
                if (!this.isSafeInternalUrl(href)) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.linkWarningUrl = href;
                    this.linkWarningVisible = true;
                }
            }
        },
        handleLinkWarningConfirm(url) {
            const opener = window._originalOpen || window.open;
            opener.call(window, url, '_blank', 'noopener,noreferrer');
            this.linkWarningVisible = false;
        },
        recallGlobalMessage() {
            console.log('[App] recallGlobalMessage called, contextTargetMessage:', this.contextTargetMessage);
            if (this.contextTargetMessage) {
                console.log('[App] Emitting global-recall-message event');
                eventBus.emit('global-recall-message', this.contextTargetMessage);
                this.hideContextMenu();
            }
        },
        formatTime(num) {
        return num.toString().padStart(2, '0');
    },
        getWallpaperByHour(hour) {
        const timeMap = [
            { max: 2, img: 'Abstract_Landscape_1.webp' },
            { max: 4, img: 'Abstract_Landscape_2.webp' },
            { max: 5, img: 'Abstract_Landscape_3.webp' },
            { max: 6, img: 'Abstract_Landscape_4.webp' },
            { max: 7, img: 'Abstract_Landscape_5.webp' },
            { max: 8, img: 'Abstract_Landscape_6.webp' },
            { max: 11, img: 'Abstract_Landscape_7.webp' },
            { max: 14, img: 'Abstract_Landscape_8.webp' },
            { max: 17, img: 'Abstract_Landscape_9.webp' },
            { max: 18, img: 'Abstract_Landscape_10.webp' },
            { max: 19, img: 'Abstract_Landscape_11.webp' },
            { max: 20, img: 'Abstract_Landscape_12.webp' },
            { max: 21, img: 'Abstract_Landscape_13.webp' },
            { max: 22, img: 'Abstract_Landscape_14.webp' },
            { max: 23, img: 'Abstract_Landscape_15.webp' },
            { max: 24, img: 'Abstract_Landscape_16.webp' }
        ];
        // 查找匹配的壁纸，如果没有找到则返回最后一个壁纸
        return timeMap.find(item => hour < item.max)?.img || timeMap[timeMap.length - 1].img;
        },
        wallpapertoggle() {
        this.applyWallpaper();
        },
        // 根据用户壁纸偏好应用背景
        applyWallpaper() {
        const body = document.querySelector(".framework");
        if (!body) return;

        // 未登录时清空缓存并使用默认时段壁纸
        const token = localStorage.getItem('userToken')
        if (!token) {
            this.wallpaperPrefs = null
            const now = new Date();
            const imgName = this.getWallpaperByHour(now.getHours());
            body.style.backgroundImage = `url(${assetsUrl}/4yshop/img/${imgName})`;
            return;
        }

        const wp = this.wallpaperPrefs
        // 无偏好或默认模式 → 时段切换
        if (!wp || !wp.mode || wp.mode === 'default') {
            const now = new Date();
            const imgName = this.getWallpaperByHour(now.getHours());
            body.style.backgroundImage = `url(${assetsUrl}/4yshop/img/${imgName})`;
            return;
        }
        // 第三方随机图 API：按小时附加缓存戳，每小时刷新一次
        if (wp.mode === 'api' && wp.apiUrl) {
            const d = new Date();
            const bust = `${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}`;
            const sep = wp.apiUrl.includes('?') ? '&' : '?';
            body.style.backgroundImage = `url(${wp.apiUrl}${sep}_wp=${bust})`;
            return;
        }
        // 用户上传的固定壁纸
        if (wp.mode === 'upload' && wp.uploadUrl) {
            body.style.backgroundImage = `url(${serverUrl}${wp.uploadUrl})`;
            return;
        }
        // 兜底：时段切换
        const now = new Date();
        const imgName = this.getWallpaperByHour(now.getHours());
        body.style.backgroundImage = `url(${assetsUrl}/4yshop/img/${imgName})`;
        },
        // 加载当前用户的壁纸偏好
        async loadWallpaperPrefs() {
        const token = localStorage.getItem('userToken')
        if (!token) {
            this.wallpaperPrefs = null
            this.wallpaperPrefsLoaded = true
            return
        }
        try {
            const res = await axios.get(`${serverUrl}/api/prefs/wallpaper`)
            if (res.data && res.data.success) {
            this.wallpaperPrefs = res.data.data || null
            } else {
            this.wallpaperPrefs = null
            }
        } catch (e) {
            this.wallpaperPrefs = null
        } finally {
            this.wallpaperPrefsLoaded = true
        }
        },
        // 壁纸偏好变更后重新加载并应用
        async onWallpaperChanged() {
        await this.loadWallpaperPrefs()
        this.applyWallpaper()
        },
        // 用户登出/token失效：清除壁纸偏好缓存并恢复默认
        onAuthCleared() {
        this.wallpaperPrefs = null
        this.wallpaperPrefsLoaded = true
        this.applyWallpaper()
        },
        // 自动验证和同步用户账号
        async autoVerifyAccount() {
            try {
                // 开始自动验证账号
                const result = await authService.autoVerifyAndSync();
                
                if (result.success) {
                    switch (result.action) {
                        case 'no_local_cache':
                            // 无本地缓存，用户未登录
                            break;
                        case 'login_expired':
                            // 登录已过期，已自动退出
                            this.showLogoutMessage('登录已过期，请重新登录');
                            break;
                        case 'token_invalid':
                            // Token无效，已自动退出
                            this.showLogoutMessage('登录状态异常，请重新登录');
                            break;
                        case 'account_mismatch':
                            // 账号信息不匹配，已自动退出
                            this.showLogoutMessage('账号信息异常，请重新登录');
                            break;
                        case 'sync_completed':
                            // 账号验证成功，数据已同步
                            // 可以在这里触发用户信息更新事件
                            this.$emit('user-synced', result.userInfo);
                            break;
                    }
                } else {
                    console.error('自动验证失败:', result.error);
                    if (result.action === 'sync_failed') {
                        this.showLogoutMessage('数据同步失败，请重新登录');
                    }
                }
            } catch (error) {
                console.error('自动验证过程出错:', error);
            }
        },
        // 显示退出登录提示
        showLogoutMessage(message) {
            import('@/utils/eventBus').then(module => {
                const eventBus = module.default
                eventBus.emit('check-login-status')
            })
            // 这里可以使用消息提示组件
            try { message({ message, type: 'warning' }) } catch(e) {
              console.log(e)
            }
            // 如果需要，可以跳转到登录页面
            // this.$router.push('/login');
        },
        async checkAnnouncement() {
            try {
                const response = await fetch(`${serverUrl}/api/announcement`);
                const data = await response.json();
                if (data.success && data.data && data.data.id) {
                    const currentId = data.data.id;
                    const lastSeenId = localStorage.getItem('lastAnnouncementId');
                    if (lastSeenId !== currentId) {
                        this._pendingAnnouncementId = currentId;
                        this.showAnnouncement = true;
                        import('@/utils/eventBus').then(module => {
                            module.default.emit('announcement-opened');
                        });
                        return;
                    }
                }
            } catch (e) {
                console.warn('检查公告失败:', e);
            }
            import('@/utils/eventBus').then(module => {
                module.default.emit('announcement-check-done');
            });
        },
        showAnnouncementModal() {
            this.showAnnouncement = true;
            import('@/utils/eventBus').then(module => {
                module.default.emit('announcement-opened');
            });
        },
        // 关闭公告
        closeAnnouncement() {
            this.showAnnouncement = false;
            if (this._pendingAnnouncementId) {
                localStorage.setItem('lastAnnouncementId', this._pendingAnnouncementId);
                this._pendingAnnouncementId = null;
            }
            import('@/utils/eventBus').then(module => {
                module.default.emit('announcement-closed');
            });
        },
        // 显示登录模态框
        showLoginModal() {
            this.showLogin = true;
        },
        // 关闭登录模态框
        closeLoginModal() {
            this.showLogin = false;
        },
        // 显示注册模态框
        showRegisterModal() {
            this.showRegister = true;
        },
        // 全局下载弹窗处理
        showGlobalDownload(data) {
            this.downloadButtons = data.buttons || [];
            this.downloadModalVisible = true;
            this.currentDownloadCallback = data.callback;
        },
        handleGlobalDownload(type) {
            if (this.currentDownloadCallback) {
                this.currentDownloadCallback(type);
            }
            this.downloadModalVisible = false;
        },
        // 全局历史弹窗处理
        showGlobalHistory(data) {
            this.historyList = data.history || [];
            this.isHistoryLoading = data.loading || false;
            this.historyModalVisible = true;
            this.currentHistoryDownloadCallback = data.onDownload;
        },
        handleGlobalHistoryDownload(item) {
            if (this.currentHistoryDownloadCallback) {
                this.currentHistoryDownloadCallback(item);
            }
            this.historyModalVisible = false;
        },
        showGlobalCloudDownload(data) {
            this.cloudDownloadAppId = data.appId;
            this.cloudDownloadModalVisible = true;
            this.currentCloudDownloadCallback = data.onDownload;
        },
        handleGlobalCloudDownload(file) {
            if (this.currentCloudDownloadCallback) {
                this.currentCloudDownloadCallback(file);
            }
            this.cloudDownloadModalVisible = false;
        },
        // 全局反馈与投稿与友链申请弹窗处理
        showGlobalFeedback() {
            this.feedbackModalVisible = true;
        },
        showGlobalSubmission() {
            this.submissionModalVisible = true;
        },
        async showGlobalDonation() {
            try {
                const res = await axios.get(`${serverUrl}/api/donations/config`);
                if (res.data && res.data.success && !res.data.enabled) {
                    message.warning('打赏赞助通道已关闭，感谢您的好意！');
                    return;
                }
            } catch (e) {
                console.error('获取打赏配置失败:', e);
            }
            this.donationModalVisible = true;
        },
        showGlobalFriendLinkApply() {
            this.friendlinkApplyModalVisible = true;
        },
        // 关闭注册模态框
        closeRegisterModal() {
      this.showRegister = false;
    },
    // 🧪 UI 测试方法
    testToast(type) {
        if (type === 'success') {
            message.success('这是一条成功的测试消息！动画流畅，玻璃感十足。');
        } else {
            message.error('这是一条超长文本测试消息：localhost/api/test/very/long/path/to/verify/wrapping/and/layout/robustness/in/mobile/view/to/ensure/no/overflow. 用于测试移动端换行。');
        }
    },
    testMessageBox(type) {
        if (type === 'alert') {
            messageBox.alert('欢迎体验全新的液态玻璃主题 MessageBox！', '测试通知', { type: 'info' });
        } else if (type === 'confirm') {
            messageBox.confirm('您确定要执行这个危险的操作吗？在移动端我将从底部滑出。', '风险确认', { 
                type: 'warning',
                isDanger: true,
                onConfirm: () => message.success('已确认操作'),
                onCancel: () => message.info('已取消')
            });
        } else if (type === 'prompt') {
            messageBox.prompt('请输入您的内测邀请码：', '身份验证', {
                inputPlaceholder: '例如：ABCD-1234',
                onConfirm: (val) => message.success(`输入成功：${val}`)
            });
        }
    },
    testLoading() {
        loading.show('正在全力加载 UI 实验室数据...');
        setTimeout(() => {
            loading.hide();
            message.success('加载完成！');
        }, 3000);
    },
    testDownloadModal() {
        this.showGlobalDownload({ 
            buttons: [
                { type: 2, label: '官网获取 (120)' }, 
                { type: 3, label: '云语获取 (500)' },
                { type: 1, label: '备用网盘' }
            ],
            callback: (type) => message.info(`选择了下载渠道 type: ${type}`)
        });
    },
    testHistoryModal() {
        this.historyList = [
            { version: '1.2.0', time: '2024-03-01', note: '修复了已知问题' },
            { version: '1.1.0', time: '2024-02-15', note: '新增液态玻璃主题' }
        ];
        this.historyModalVisible = true;
    },
    testAvatarModal() {
        this.avatarModalUsername = 'Henvei';
        this.avatarModalVisible = true;
    },
    testFollowModal() {
        this.followModalType = 'follower';
        this.followModalUsers = [{ uid: 1, username: '测试用户1', avatar: '', bio: '这是个生物' }];
        this.followModalVisible = true;
    },
    testTwofaModal() {
        this.twofaDialogSecret = 'JBSWY3DPEBLW64TMMQQQ';
        this.twofaDialogOtpauth = 'otpauth://totp/4yshop:test?secret=JBSWY3DPEBLW64TMMQQQ';
        this.twofaDialogVisible = true;
    },
    testRejectModal() {
        eventBus.emit('show-reject-modal', {
            onSubmit: (reason) => message.error(`驳回成功：${reason}`)
        });
    },
    testAiResultModal() {
        eventBus.emit('show-ai-result-modal', {
            title: 'AI 审核结果',
            content: '<div class="violation-reason">内容包含敏感词汇</div><div class="violation-note">请修改后重新提交</div>',
            type: 'warning'
        });
    },
    // 从登录切换到注册
    switchToRegister() {
      this.showLogin = false;
      this.showRegister = true;
    },
    // 从注册切换到登录
    switchToLogin() {
      this.showRegister = false;
      this.showLogin = true;
    },
    // 添加全局复制监听
          addCopyListener() {
            this.copyHandler = () => {
              if (this.isInternalCopy) return; // 忽略右键菜单复制触发的全局事件，防止二次弹窗
              // 获取复制的内容
              setTimeout(() => {
                navigator.clipboard.readText().then(text => {
                  // 如果复制的内容和上次不同，才显示提示
                  if (text !== this.lastCopiedContent) {
                    this.lastCopiedContent = text;
                    // 使用Element Plus的消息提示
                    message({
                      message: '复制成功，如需转载请注明出处哦！',
                      type: 'success',
                      duration: 3000,
                      showClose: true
                    });
                  }
                }).catch(() => {
                  // 如果无法读取剪贴板，则直接显示提示（兼容性处理）
                  message({
                    message: '复制成功，如需转载请注明出处哦！',
                    type: 'success',
                    duration: 3000,
                    showClose: true
                  });
                });
              }, 10); // 延迟10ms确保剪贴板内容已更新
            };
            document.addEventListener('copy', this.copyHandler);
          },
          // 全局对话框处理方法
          handleAgreementConfirm() {
              if (this.agreementConfirmCallback) {
                  this.agreementConfirmCallback();
              }
              this.agreementModalVisible = false;
          },
          handleCloudCodeConfirm() {
              if (this.cloudCodeConfirmCallback) {
                  this.cloudCodeConfirmCallback();
              }
              this.cloudCodeModalVisible = false;
          },
          async submitUrgeUpdateFromModal(remark) {
              if (this.isUrgingUpdate) return;
              if (!authService.isLoggedIn()) {
                  message.warning('请先登录后再进行催更');
                  eventBus.emit('show-login');
                  return;
              }
              if (remark && remark.length > 100) {
                  message.warning('备注内容不能超过100个字符');
                  return;
              }
              this.isUrgingUpdate = true;
              try {
                  const user = authService.getCurrentUser();
                  const token = localStorage.getItem('userToken');
                  let db = null;
                  try {
                      const resp = await axios.get(`${serverUrl}/api/software`);
                      db = resp.data;
                  } catch (_) { /* ignore */ }
                  const appInfo = Array.isArray(db) ? db.find(a => String(a.id) === String(this.urgeUpdateAppId)) : null;
                  const response = await axios.post(`${serverUrl}/api/urge-update`, {
                      userId: user?.userId,
                      username: user?.username || '匿名用户',
                      appid: this.urgeUpdateAppId,
                      appname: appInfo ? appInfo.name : '',
                      version: appInfo ? appInfo.version : '',
                      remark: remark || ''
                  }, {
                      headers: { Authorization: `Bearer ${token}` }
                  });
                  if (response.data.success) {
                      message.success('催更请求已成功送达管理员！');
                      this.urgeUpdateDialogVisible = false;
                  } else {
                      message.error(response.data.error || '催更提交失败');
                  }
              } catch (error) {
                  console.error('催更失败:', error);
                  const status = error?.response?.status;
                  if (status === 429) {
                      message.warning(error?.response?.data?.error || '24小时内最多提交3次催更请求');
                  } else {
                      message.error(error?.response?.data?.error || '催更提交失败');
                  }
              } finally {
                  this.isUrgingUpdate = false;
              }
          },
          submitReportFromModal(reportData) {
              if (this.isReporting) return;
              this.isReporting = true;
              
              const payload = typeof reportData === 'object' ? reportData : {
                  targetId: this.reportTargetId,
                  targetUsername: this.reportTargetUsername,
                  reason: reportData
              };

              axios.post(`${serverUrl}/api/report`, payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('userToken')}` }
              }).then(res => {
                  if (res.data && res.data.success) {
                      message.success('举报已提交，我们会尽快处理');
                      this.showReportModal = false;
                  } else {
                      message.error((res.data && res.data.error) || '举报提交失败');
                  }
              }).catch((err) => {
                  const status = err?.response?.status;
                  if (status === 401) {
                      message.error('登录状态异常，请重新登录');
                      eventBus.emit('show-login');
                  } else {
                      message.error(err?.response?.data?.error || '举报提交失败');
                  }
              }).finally(() => {
                  this.isReporting = false;
              });
          },
        // 全局右键菜单相关方法
        showContextMenu(event) {
          // 保存右键触发的目标元素
          this.contextMenuTarget = event.target;

          // 检查是否在文章编辑页面的内容编辑器区域
          if (this.$route.path.includes('/article/edit') || this.$route.name === 'ArticleEdit') {
            const target = event.target;
            if (target && target.classList && target.classList.contains('content-editor')) {
              return;
            }
          }
          
          event.preventDefault();
          
          // 默认清空聊天目标
          this.contextMenuTargetPeerId = '';
          this.isContextDnd = false;
          this.isContextBlacklisted = false;
          this.contextMenuTargetPeerId = '';
          this.isContextDnd = false;
          this.isContextBlacklisted = false;
          this.contextTargetRemark = '';
          this.contextTargetUserId = ''; // 重置通用ID
          
          // 判断是否为评论卡片
          this.canAddFriendFlag = false;
          this.contextTargetUsername = '';
          const cardEl = event.target.closest && event.target.closest('.comment-item, .reply-item');
          if (cardEl) {
            // 文章/工具评论区的作者元素
            const authorEl = cardEl.querySelector('.comment-author, .reply-author, .comment-username, .reply-username');
            let uname = '';
            if (authorEl) {
              const attrName = (authorEl.getAttribute('data-username') || (authorEl.dataset && authorEl.dataset.username) || '').trim();
              const textName = (authorEl.textContent || '').trim();
              uname = attrName || textName;
              
              // 尝试获取 data-user-id
              const uid = (authorEl.getAttribute('data-user-id') || (authorEl.dataset && authorEl.dataset.userId) || '').trim();
              if (uid) this.contextTargetUserId = uid;
            }
            // 识别到用户名即显示“查看用户”，不再限制为他人
            if (uname) {
              this.contextTargetUsername = uname;
              this.canAddFriendFlag = true;
            } else {
              // 回退：尝试从更近的头部区域获取
              const headerEl = event.target.closest && event.target.closest('.comment-header, .reply-header');
              const headerAuthor = headerEl ? headerEl.querySelector('.comment-author, .reply-author, .comment-username, .reply-username') : null;
              let headerName = '';
              if (headerAuthor) {
                const attrName = (headerAuthor.getAttribute('data-username') || (headerAuthor.dataset && headerAuthor.dataset.username) || '').trim();
                const textName = (headerAuthor.textContent || '').trim();
                headerName = attrName || textName;
              }
              if (headerName) {
                this.contextTargetUsername = headerName;
                this.canAddFriendFlag = true;
              }
            }
          }
          
          // 聊天界面好友卡片识别（增加坐标命中回退）
          let friendEl = (event.target && event.target.closest && event.target.closest('.friend-item')) || null;
          if (!friendEl && document && document.elementFromPoint) {
            const elAtPoint = document.elementFromPoint(event.clientX, event.clientY);
            friendEl = elAtPoint && elAtPoint.closest ? elAtPoint.closest('.friend-item') : null;
          }
          if (friendEl) {
            const pid = (friendEl.getAttribute('data-user-id') || (friendEl.dataset && friendEl.dataset.userId) || '').trim();
            if (pid) {
              const noManage = friendEl.getAttribute("data-no-manage");
              if (noManage && noManage === "true") {
                  this.contextMenuTargetPeerId = "";
              } else {
                  this.contextMenuTargetPeerId = String(pid);
              }
              // Set contextTargetUserId so that viewTargetUser can work correctly
              this.contextTargetUserId = String(pid);
              
              if (this.contextMenuTargetPeerId) {
                  const dndMap = this.userPrefs.dndPeers || {};
                  this.isContextDnd = !!dndMap[this.contextMenuTargetPeerId];
                  const bl = Array.isArray(this.userPrefs.blacklist) ? this.userPrefs.blacklist.map(x => String(x)) : [];
                  this.isContextBlacklisted = bl.includes(this.contextMenuTargetPeerId);
              }
              this.contextTargetUsername = (friendEl.getAttribute('data-username') || (friendEl.dataset && friendEl.dataset.username) || '').trim();
              this.contextTargetRemark = (friendEl.getAttribute('data-remark') || (friendEl.dataset && friendEl.dataset.remark) || '');
              if (this.contextTargetUsername) {
                this.canAddFriendFlag = true;
              }
          }
          }
          
          // 文章详情页头部作者识别
          if (!this.canAddFriendFlag) {
            const articleHeaderEl = event.target.closest && event.target.closest('.article-header');
            if (articleHeaderEl) {
              const headerAuthorEl = articleHeaderEl.querySelector('.article-author');
              let headerName = '';
              if (headerAuthorEl) {
                 const attrName = (headerAuthorEl.getAttribute('data-username') || (headerAuthorEl.dataset && headerAuthorEl.dataset.username) || '').trim();
                 const textName = (headerAuthorEl.textContent || '').trim();
                 headerName = attrName || textName;
              }
              if (headerName) {
                this.contextTargetUsername = headerName;
                this.canAddFriendFlag = true;
                
                // 尝试获取 data-user-id
                const uid = (headerAuthorEl.getAttribute('data-user-id') || (headerAuthorEl.dataset && headerAuthorEl.dataset.userId) || '').trim();
                if (uid) {
                    this.contextTargetUserId = uid;
                }
              }
            }
          }

          // 我的收藏卡片识别（用于“取消收藏”）
          this.contextMenuTargetAppId = '';
          const favoritesListEl = event.target.closest && event.target.closest('.favorites-flex');
          if (favoritesListEl) {
            const cardEl = (event.target.closest && event.target.closest('.kedianji')) || null;
            let appId = '';
            if (cardEl) {
              const idEl = cardEl.querySelector('[data-id]');
              appId = idEl ? (idEl.getAttribute('data-id') || idEl.dataset?.id || '').trim() : '';
            } else {
              const idAncestor = event.target.closest && event.target.closest('[data-id]');
              appId = idAncestor ? (idAncestor.getAttribute('data-id') || idAncestor.dataset?.id || '').trim() : '';
            }
            if (appId) {
              this.contextMenuTargetAppId = appId;
            }
          }

          // 消息撤回识别
          this.contextTargetMessage = null;
          const bubbleEl = event.target.closest && event.target.closest('.bubble');
          if (bubbleEl) {
              const isMine = bubbleEl.getAttribute('data-is-mine') === 'true';
              const timestamp = parseInt(bubbleEl.getAttribute('data-timestamp') || '0');
              const msgId = bubbleEl.getAttribute('data-message-id');
              
              if (isMine && msgId && timestamp) {
                  // 2分钟限制
                  if (Date.now() - timestamp <= 2 * 60 * 1000) {
                      this.contextTargetMessage = {
                          id: msgId,
                          type: bubbleEl.getAttribute('data-type') || 'unknown'
                      };
                  }
              }
          }

          // 保存当前焦点元素
          this.lastFocusedElement = document.activeElement;
          
          // 获取选中的文本
          const selection = window.getSelection();
          this.selectedText = selection.toString().trim();
          
          let x = event.clientX;
          let y = event.clientY;

          this.contextMenuX = x;
          this.contextMenuY = y;
          this.contextMenuVisible = true;

          // 智能调整位置防止溢出视口
          this.$nextTick(() => {
            const menu = this.$refs.contextMenu;
            if (menu) {
                const { offsetWidth: menuWidth, offsetHeight: menuHeight } = menu;
                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;
                
                // 如果右侧溢出，则向左偏移
                if (x + menuWidth > windowWidth - 10) {
                    x = windowWidth - menuWidth - 10;
                    if (x < 10) x = 10;
                }
                
                // 如果底部溢出，则向上偏移
                if (y + menuHeight > windowHeight - 10) {
                    y = windowHeight - menuHeight - 10;
                    if (y < 10) y = 10;
                }
                
                this.contextMenuX = x;
                this.contextMenuY = y;
            }
            
            // 在捕获阶段监听全局点击/按下事件，防止对话框内部 click.stop 阻断隐藏逻辑
            document.addEventListener('click', this.hideContextMenu, true);
            document.addEventListener('pointerdown', this.hideContextMenu, true);
            document.addEventListener('wheel', this.hideContextMenu, true);
          });
        },
        hideContextMenu(event) {
          // 如果点击的目标在右键菜单内部，不进行全局关隐
          if (event && event.target && this.$refs.contextMenu && this.$refs.contextMenu.contains(event.target)) {
            return;
          }

          this.contextMenuVisible = false;
          this.selectedText = '';
          this.canAddFriendFlag = false;
          this.contextMenuTargetAppId = '';
          this.contextTargetMessage = null;
          
          document.removeEventListener('click', this.hideContextMenu, true);
          document.removeEventListener('pointerdown', this.hideContextMenu, true);
          document.removeEventListener('wheel', this.hideContextMenu, true);
        },
        copySelectedText() {
            const selection = window.getSelection();
            const textToCopy = this.selectedText || (selection ? selection.toString().trim() : '');
            
            if (textToCopy) {
              this.isInternalCopy = true;
              const target = this.contextMenuTarget || this.lastFocusedElement;
              const isEditable = target && (
                target.tagName === 'INPUT' || 
                target.tagName === 'TEXTAREA' || 
                target.contentEditable === 'true' ||
                (typeof target.closest === 'function' && (
                  target.closest('input') ||
                  target.closest('textarea') ||
                  target.closest('[contenteditable="true"]')
                ))
              );
              const copyMsg = isEditable ? '复制成功！' : '复制成功，如需转载请注明出处哦！';

              // 通用移动端/桌面端超级兼容复制算法
              let success = false;
              try {
                const textArea = document.createElement('textarea');
                textArea.value = textToCopy;
                textArea.style.position = 'fixed';
                textArea.style.top = '0';
                textArea.style.left = '-9999px';
                textArea.style.opacity = '0';
                textArea.setAttribute('readonly', '');
                document.body.appendChild(textArea);

                // iOS 移动端选区兼容
                if (navigator.userAgent.match(/iphone|ipad|ipod/i)) {
                  const range = document.createRange();
                  range.selectNodeContents(textArea);
                  const sel = window.getSelection();
                  if (sel) {
                    sel.removeAllRanges();
                    sel.addRange(range);
                  }
                  textArea.setSelectionRange(0, 999999);
                } else {
                  textArea.select();
                }

                success = document.execCommand('copy');
                document.body.removeChild(textArea);
              } catch (e) {
                success = false;
              }

              if (success) {
                message({ message: copyMsg, type: 'success', duration: 2000 });
                this.isInternalCopy = false;
              } else if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(textToCopy).then(() => {
                  message({ message: copyMsg, type: 'success', duration: 2000 });
                  this.isInternalCopy = false;
                }).catch(() => {
                  message({ message: '复制失败，请重试', type: 'error', duration: 2000 });
                  this.isInternalCopy = false;
                });
              } else {
                message({ message: '复制失败，请重试', type: 'error', duration: 2000 });
                this.isInternalCopy = false;
              }
            } else {
              message({
                message: '请先选择要复制的文本',
                type: 'warning',
                duration: 2000
              });
            }
            this.hideContextMenu();
          },
          pasteText() {
           navigator.clipboard.readText().then(text => {
             if (text) {
               // 使用保存的焦点元素，如果没有则使用当前焦点元素
               const targetElement = this.lastFocusedElement || document.activeElement;
               
               // 检查是否是可编辑的元素
               if (targetElement && (
                 targetElement.tagName === 'INPUT' || 
                 targetElement.tagName === 'TEXTAREA' || 
                 targetElement.contentEditable === 'true'
               )) {
                 // 重新聚焦到目标元素
                 targetElement.focus();
                 
                 // 在光标位置插入文本
                 if (targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA') {
                   const start = targetElement.selectionStart;
                   const end = targetElement.selectionEnd;
                   const value = targetElement.value;
                   targetElement.value = value.substring(0, start) + text + value.substring(end);
                   targetElement.selectionStart = targetElement.selectionEnd = start + text.length;
                 } else if (targetElement.contentEditable === 'true') {
                   // 对于contentEditable元素
                   document.execCommand('insertText', false, text);
                 }
                 
                 message({
                   message: '粘贴成功！',
                   type: 'success',
                   duration: 2000
                 });
               } else {
                 message({
                   message: '请先点击要粘贴的输入框',
                   type: 'warning',
                   duration: 2000
                 });
               }
             } else {
               message({
                 message: '剪贴板为空',
                 type: 'warning',
                 duration: 2000
               });
             }
           }).catch(() => {
             message({
               message: '无法访问剪贴板，请使用Ctrl+V粘贴',
               type: 'error',
               duration: 3000
             });
           });
           
           this.hideContextMenu();
         },
         selectAllText() {
            this.isSelectingAll = true; // 开启防飘标识
            const selection = window.getSelection();
            const x = this.contextMenuX;
            const y = this.contextMenuY;
            let anchorEl = null;
            if (typeof document.elementFromPoint === 'function') {
              anchorEl = document.elementFromPoint(x, y);
            }

            // 优先处理可编辑输入框
            const inputLike = anchorEl && (anchorEl.tagName === 'INPUT' || anchorEl.tagName === 'TEXTAREA')
              ? anchorEl
              : null;
            if (inputLike) {
              inputLike.focus();
              inputLike.select();
              message({ message: '已全选文本', type: 'success', duration: 2000 });
              this.selectedText = inputLike.value;
              setTimeout(() => {
                this.isSelectingAll = false;
              }, 150);
              return;
            }

            // 处理 contentEditable 容器
            let editableContainer = anchorEl;
            while (editableContainer && editableContainer !== document.body) {
              if (editableContainer.contentEditable === 'true') break;
              editableContainer = editableContainer.parentElement;
            }
            if (editableContainer && editableContainer.contentEditable === 'true') {
              editableContainer.focus();
              const range = document.createRange();
              range.selectNodeContents(editableContainer);
              selection.removeAllRanges();
              selection.addRange(range);
              message({ message: '已全选内容', type: 'success', duration: 2000 });
              this.selectedText = selection.toString().trim();
              setTimeout(() => {
                this.isSelectingAll = false;
              }, 150);
              return;
            }

            // 基于右击坐标定位文本节点
            let textRange = null;
            if (typeof document.caretRangeFromPoint === 'function') {
              textRange = document.caretRangeFromPoint(x, y);
            } else if (typeof document.caretPositionFromPoint === 'function') {
              const pos = document.caretPositionFromPoint(x, y);
              if (pos) {
                textRange = document.createRange();
                textRange.setStart(pos.offsetNode, pos.offset);
                textRange.collapse(true);
              }
            }

            // 寻找块级容器（避免整页全选）
            let container = anchorEl || document.body;
            if (textRange && textRange.startContainer) {
              container = textRange.startContainer.nodeType === Node.TEXT_NODE
                ? textRange.startContainer.parentElement
                : textRange.startContainer;
            }
            while (container && container !== document.body) {
              const style = window.getComputedStyle(container);
              if (style.display !== 'inline') break;
              container = container.parentElement;
            }
            if (!container || container === document.body) {
              message({ message: '请在文本上右击使用全选', type: 'warning', duration: 2000 });
              this.isSelectingAll = false;
              return;
            }

            const range = document.createRange();
            range.selectNodeContents(container);
            selection.removeAllRanges();
            selection.addRange(range);
            const preview = (container.textContent || '').trim().substring(0, 20);
            message({ message: `已选中该块内容: "${preview}..."`, type: 'success', duration: 2000 });
            this.selectedText = selection.toString().trim();
            
            setTimeout(() => {
              this.isSelectingAll = false;
            }, 200);
          },
                  // 图片查看器相关方法
         openImageViewer(imageSrc, imageAlt = '图片') {
           this.currentImageSrc = imageSrc;
           this.currentImageAlt = imageAlt;
           this.imageViewerVisible = true;
         },
         
         closeImageViewer() {
           this.imageViewerVisible = false;
           this.currentImageSrc = '';
           this.currentImageAlt = '';
         },
         
         handleImageDoubleClick(event) {
           // 检查双击的元素是否是图片
           if (event.target.tagName === 'IMG') {
             const img = event.target;
             const src = img.src || img.getAttribute('data-src');
             const alt = img.alt || '图片';
             
             if (src) {
               this.openImageViewer(src, alt);
             }
           }
         },
         
         // 图片悬停提示相关方法
         handleImageMouseEnter(event) {
           if (event.target.tagName === 'IMG') {
             // 检查图片是否在AppCard或TuijianCard组件内
             const appCard = event.target.closest('.kedianji');
             const tuijianCard = event.target.closest('.tuijian-card');
             // 检查图片是否在ImageViewer组件内
             const imageViewer = event.target.closest('.image-viewer-overlay');
             
             // 如果图片在这些组件内，不显示悬停提示
             if (appCard || tuijianCard || imageViewer) {
               return;
             }
             
             // 清除之前的定时器
             if (this.imageTooltipTimer) {
               clearTimeout(this.imageTooltipTimer);
               this.imageTooltipTimer = null;
             }
             
             this.hoveredImage = event.target;
             this.updateTooltipPosition(event);
             
             // 延迟1秒后显示提示
             this.imageTooltipTimer = setTimeout(() => {
               this.imageTooltipVisible = true;
               this.imageTooltipTimer = null;
             }, 1000);
           }
         },
         
         handleImageMouseLeave(event) {
           if (event.target.tagName === 'IMG') {
             // 清除延迟定时器
             if (this.imageTooltipTimer) {
               clearTimeout(this.imageTooltipTimer);
               this.imageTooltipTimer = null;
             }
             
             this.imageTooltipVisible = false;
             this.hoveredImage = null;
           }
         },
         
         handleImageMouseMove(event) {
           if (this.imageTooltipVisible && event.target.tagName === 'IMG') {
             this.updateTooltipPosition(event);
           }
         },
         
         updateTooltipPosition(event) {
           this.imageTooltipX = event.clientX + 10;
           this.imageTooltipY = event.clientY - 30;
         },
         
         // 注入动态字体（兜底）
         injectDynamicFonts() {
             const styleId = 'global-dynamic-fonts';
             if (document.getElementById(styleId) || document.getElementById('dynamic-font-styles')) return;

             const style = document.createElement('style');
             style.id = styleId;
             style.textContent = `
                 @font-face {
                     font-family: '猫啃网糖圆体';
                     src: local('猫啃网糖圆体'), local('MaokenTangyuan'),
                          url('${assetsUrl}/4yshop/font/猫啃网糖圆体.woff2') format('woff2'),  
                          url('${assetsUrl}/4yshop/font/猫啃网糖圆体.woff') format('woff'),
                          url('${assetsUrl}/4yshop/font/猫啃网糖圆体.ttf') format('truetype'); 
                     font-weight: 100 900;  
                     font-style: normal;
                     font-display: swap;  
                 }
                 @font-face {
                     font-family: '爱点风雅黑';
                     src: local('爱点风雅黑'), local('AidianFengYahei'),
                          url('${assetsUrl}/4yshop/font/爱点风雅黑.woff2') format('woff2'),  
                          url('${assetsUrl}/4yshop/font/爱点风雅黑.woff') format('woff'),
                          url('${assetsUrl}/4yshop/font/爱点风雅黑.ttf') format('truetype'); 
                     font-weight: 100 900;  
                     font-style: normal;
                     font-display: swap;  
                 }
             `;
             document.head.appendChild(style);
         },
         // 初始化用户与偏好
         async initUserAndPrefs() {
           try {
             const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
             this.userId = info.userId || null
           } catch (e) { this.userId = null }
           if (!this.userId) return
           this.loadPrefsAndFriends()
         },
         async loadPrefsAndFriends() {
  if (!this.userId) return
  try {
    const p = await prefsService.getPrefs(this.userId)
    if (p.success) this.userPrefs = p.data || this.userPrefs
    
    const newFriendMap = {}
    
    const lst = await followService.getList(this.userId)
    if (lst.success) {
      const followingDetails = lst.data.followingDetails || []
      const followerDetails = lst.data.followerDetails || []
      
      followingDetails.forEach(u => {
          newFriendMap[u.userId] = { ...newFriendMap[u.userId], ...u }
      })
      followerDetails.forEach(u => {
          newFriendMap[u.userId] = { ...newFriendMap[u.userId], ...u }
      })
    }
    
    this.friendMap = newFriendMap
  } catch (e) { console.error('[App] loadPrefsAndFriends failed:', e) }
},
async handleIncomingMessage(message) {
           if (!message || !this.userId) return
           if (String(message.to) !== String(this.userId)) return
           const sender = String(message.from || '')
           // 防重复：同一消息在短时间内只弹一次
           const rawContent = String(message.content || '')
           const dedupeKey = `${sender}|${rawContent}`
           const now = Date.now()
           if (this.lastNotifiedKey === dedupeKey && (now - this.lastNotifiedTime) < 2000) {
             return
           }
           this.lastNotifiedKey = dedupeKey
           this.lastNotifiedTime = now
           const blRaw = Array.isArray(this.userPrefs.blacklist) ? this.userPrefs.blacklist : []
           const bl = blRaw.map(x => String(x))
           if (bl.includes(sender)) return // 黑名单不弹窗
           const dndMap = this.userPrefs.dndPeers || {}
           if (dndMap[sender]) return // 免打扰不弹窗
           let u = this.friendMap[sender]
           // 回退：若未加载到好友详情，尝试即时查询用户名
           if (!u) {
             try {
               const lookup = await userService.lookupUsernameByUserId(sender)
               if (lookup && lookup.success && lookup.data) {
                 const info = lookup.data.info || {}
                 u = {
                     userId: sender,
                     username: lookup.data.username,
                     nickname: info.nickname || '',
                     avatar: info.avatar || ''
                 }
                 // 缓存到 friendMap 以便后续使用
                 this.friendMap = { ...(this.friendMap || {}), [sender]: u }
               }
             } catch (e) { /* ignore */ }
           }
           const displayName = u ? (u.remark || (this.userPrefs?.remarks?.[u.userId] || this.userPrefs?.remarks?.[sender]) || u.nickname || u.username || u.userId) : ((this.userPrefs?.remarks?.[sender]) || sender || '好友')
           const snippet = (message.content || '').slice(0, 60)

           // 最终使用的显示名称直接采用优先级处理后的 displayName
           const displayNickname = displayName

           // 头像处理逻辑：优先调用后端接口获取
           let avatarUrl = ''
           if (u && u.username) {
             try {
               const env = process.env.NODE_ENV === 'development' ? 'development' : 'production';
               const resp = await axios.get(`${serverUrl}/api/get-avatar-url`, {
                 params: { username: u.username, env }
               });
               if (resp && resp.data && resp.data.success && resp.data.url) {
                 avatarUrl = resp.data.url;
               }
             } catch (e) {
               // 接口失败，下一步尝试拼接
             }
           }

           // 如果接口没拿到，或者没有用户名，则尝试根据 u.avatar 拼接（兜底逻辑）
           if (!avatarUrl && u && u.avatar) {
             const av = String(u.avatar);
             if (av.startsWith('http')) {
               avatarUrl = av;
             } else if (av.startsWith('/assets/')) {
               avatarUrl = `${serverUrl.replace(/\/$/, '')}${av}`;
             } else if (av.startsWith('/')) {
               avatarUrl = `${baseAvatarUrl}${av}`;
             } else {
               avatarUrl = `${baseAvatarUrl}/avatar/${av}`;
             }
           }

          // 备注（若存在则在昵称下方弱化显示）
          const remark = (u && (u.remark || this.userPrefs?.remarks?.[u.userId] || this.userPrefs?.remarks?.[sender])) || ''

          // 构造带头像与昵称的内容节点
          const contentNode = h('div', { style: 'display:flex;align-items:center;gap:10px;' }, [
            avatarUrl
              ? h('img', {
                  src: avatarUrl,
                  alt: displayNickname,
                  style: 'width:32px;height:32px;border-radius:50%;object-fit:cover;flex-shrink:0;'
                })
              : h('div', {
                  style: 'width:32px;height:32px;border-radius:50%;background:#6f8dfd;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;flex-shrink:0;'
                }, (displayNickname || '友').charAt(0).toUpperCase()),
            h('div', {}, [
              h('div', { style: 'font-weight:600;font-size:14px;' }, displayNickname),
              remark ? h('div', { style: 'font-size:12px;color:#909399;margin-top:2px;' }, `备注：${remark}`) : null,
              h('div', { style: 'margin-top:4px;font-size:13px;line-height:1.4;' }, snippet)
            ])
          ])

          // 使用 Element Plus 弹窗样式（点击跳转聊天）
          notification({
            title: '新消息 📩',
            message: contentNode,
            type: 'info',
            duration: 5000,
            onClick: () => {
              if (this.$router) {
                this.$router.push({ name: 'Chat', query: { peerId: sender } })
              }
            }
          })
         },
         onPrefsUpdated(payload) {
           const prefs = (payload && payload.prefs) ? payload.prefs : (payload || {})
           const prev = this.userPrefs || {}
           const next = {
             blacklist: Array.isArray(prefs.blacklist) ? prefs.blacklist.slice() : (prev.blacklist || []),
             dndPeers: { ...(prev.dndPeers || {}), ...(prefs.dndPeers || {}) },
             globalDnd: typeof prefs.globalDnd === 'boolean' ? prefs.globalDnd : prev.globalDnd,
             remarks: { ...(prev.remarks || {}), ...(prefs.remarks || {}) }
           }
           this.userPrefs = next
         },

         // UI Lab 移动端底部抽屉样式
         showMobileBottomDrawer(componentName, props = {}) {
           this.mobileBottomDrawerComponent = componentName;
           this.mobileBottomDrawerProps = props;
           this.isMobileBottomDrawerVisible = true;
         },
         hideMobileBottomDrawer() {
           this.isMobileBottomDrawerVisible = false;
           this.mobileBottomDrawerComponent = null;
           this.mobileBottomDrawerProps = {};
         },

         async viewTargetUser() {
           this.hideContextMenu()
           if (this.contextTargetUserId) {
               this.$router.push({ name: "UserProfile", params: { userId: String(this.contextTargetUserId) } })
               return
           }
           const targetName = (this.contextTargetUsername || '').trim()
           if (!targetName) {
             // 在文章详情页，尝试由文章ID解析作者ID
             if (this.$route && this.$route.name === 'ArticleDetails') {
               const s = String(this.$route.params && this.$route.params.id || '')
               const idx = s.lastIndexOf('_')
               const parsedId = idx >= 0 ? s.slice(idx + 1) : ''
               if (parsedId) {
                 this.$router.push({ name: 'UserProfile', params: { userId: String(parsedId) } })
                 return
               }
             }
             message({ message: '未识别到目标用户名', type: 'error' })
             return
           }
           try {
             const lookup = await userService.lookupUserIdByUsername(targetName)
             let toUserId = ''
             if (lookup && lookup.success && lookup.data && lookup.data.userId) {
               toUserId = String(lookup.data.userId)
             } else if (this.$route && this.$route.name === 'ArticleDetails') {
               // 作为回退：由文章ID解析作者ID
               const s = String(this.$route.params && this.$route.params.id || '')
               const idx = s.lastIndexOf('_')
               const parsedId = idx >= 0 ? s.slice(idx + 1) : ''
               toUserId = parsedId ? String(parsedId) : ''
             }
             if (!toUserId) {
               message({ message: (lookup && lookup.message) || '未找到该用户', type: 'error' })
               return
             }
             this.$router.push({ name: 'UserProfile', params: { userId: toUserId } })
           } catch (e) {
             message({ message: '网络异常，稍后再试', type: 'error' })
           }
         },
         // 聊天卡片右键：免打扰/拉黑/备注
         async toggleContextDnd() {
           this.hideContextMenu()
           let peerId = this.contextMenuTargetPeerId
           if (!peerId) {
             const activeEl = document.querySelector('.friend-item.active')
             peerId = (activeEl && (activeEl.getAttribute('data-user-id') || activeEl.dataset?.userId) || '').trim()
           }
           if (!peerId && this.$route?.name === 'Chat') {
             peerId = String(this.$route?.query?.peerId || '')
           }
           if (!peerId) {
             message({ message: '未识别到目标，请在好友卡片上右键', type: 'warning' })
             return
           }
           if (!this.userId) {
             message({ message: '请先登录后再设置免打扰', type: 'warning' })
             eventBus.emit('show-login')
             return
           }
           try {
             const targetState = !this.isContextDnd
             const res = await prefsService.setDnd(this.userId, peerId, targetState)
             if (res && res.success) {
               const map = this.userPrefs.dndPeers || {}
               map[peerId] = targetState
               this.userPrefs.dndPeers = { ...map }
               this.isContextDnd = targetState
               this.contextMenuTargetPeerId = peerId
               eventBus.emit('prefs-updated', { userId: this.userId, prefs: this.userPrefs })
               message({ message: targetState ? '已开启免打扰' : '已关闭免打扰', type: 'success' })
             } else {
               message({ message: (res && res.message) || '操作失败', type: 'error' })
             }
           } catch (e) {
             message({ message: '网络异常，稍后再试', type: 'error' })
           }
         },
         async toggleContextBlacklist() {
           this.hideContextMenu()
           let peerId = this.contextMenuTargetPeerId
           if (!peerId) {
             const activeEl = document.querySelector('.friend-item.active')
             peerId = (activeEl && (activeEl.getAttribute('data-user-id') || activeEl.dataset?.userId) || '').trim()
           }
           if (!peerId && this.$route?.name === 'Chat') {
             peerId = String(this.$route?.query?.peerId || '')
           }
           if (!peerId) {
             message({ message: '未识别到目标，请在好友卡片上右键', type: 'warning' })
             return
           }
           if (!this.userId) {
             message({ message: '请先登录后再进行操作', type: 'warning' })
             eventBus.emit('show-login')
             return
           }
           try {
             if (this.isContextBlacklisted) {
               const r = await prefsService.removeFromBlacklist(this.userId, peerId)
               if (r && r.success) {
                 const bl = Array.isArray(this.userPrefs.blacklist) ? this.userPrefs.blacklist.filter(x => String(x) !== String(peerId)) : []
                 this.userPrefs.blacklist = bl
                 this.isContextBlacklisted = false
                 this.contextMenuTargetPeerId = peerId
                 eventBus.emit('prefs-updated', { userId: this.userId, prefs: this.userPrefs })
                 message({ message: '已取消拉黑', type: 'success' })
               } else {
                 message({ message: (r && r.message) || '取消拉黑失败', type: 'error' })
               }
             } else {
               const r = await prefsService.addToBlacklist(this.userId, peerId)
               if (r && r.success) {
                 const bl = Array.isArray(this.userPrefs.blacklist) ? this.userPrefs.blacklist.slice() : []
                 this.userPrefs.blacklist = [...bl, String(peerId)]
                 this.isContextBlacklisted = true
                 this.contextMenuTargetPeerId = peerId
                 eventBus.emit('prefs-updated', { userId: this.userId, prefs: this.userPrefs })
                 message({ message: '已拉黑该用户', type: 'success' })
               } else {
                 message({ message: (r && r.message) || '拉黑失败', type: 'error' })
               }
             }
           } catch (e) {
             message({ message: '网络异常，稍后再试', type: 'error' })
           }
         },
         async openEditRemarkDialog() {
           this.hideContextMenu()
           let peerId = this.contextMenuTargetPeerId
           if (!peerId) {
             const activeEl = document.querySelector('.friend-item.active')
             peerId = (activeEl && (activeEl.getAttribute('data-user-id') || activeEl.dataset?.userId) || '').trim()
           }
           if (!peerId && this.$route?.name === 'Chat') {
             peerId = String(this.$route?.query?.peerId || '')
           }
           if (!peerId) {
             message({ message: '未识别到目标，请在好友卡片上右键', type: 'warning' })
             return
           }
           if (!this.userId) {
             message({ message: '请先登录后再修改备注', type: 'warning' })
             eventBus.emit('show-login')
             return
           }
           // 修改备注逻辑：改为使用自定义弹窗
           this.contextTargetRemark = this.userPrefs?.remarks?.[peerId] || ''
           this.currentAlias = this.contextTargetRemark
           this.contextMenuTargetPeerId = peerId
           this.showModifyAliasModal = true
          },
          async submitModifyAlias(remark) {
           const peerId = this.contextMenuTargetPeerId
           if (!this.userId || !peerId) return
           
           this.isModifyingAlias = true
           try {
               const r = await followService.setRemark(this.userId, peerId, remark)
               if (r && r.success) {
                  const prev = this.friendMap[peerId] || {}
                  this.friendMap = { ...(this.friendMap || {}), [peerId]: { ...prev, remark } }
                  // 同步
                  const rmap = this.userPrefs.remarks && typeof this.userPrefs.remarks === 'object' ? this.userPrefs.remarks : {}
                 this.userPrefs.remarks = { ...rmap, [peerId]: remark }
                 this.contextTargetRemark = remark
                  eventBus.emit('friends-updated');
                  eventBus.emit('prefs-updated', { userId: this.userId, prefs: this.userPrefs });
                  message({ message: '备注已更新', type: 'success' });
                  this.showModifyAliasModal = false;
               } else {
                 message({ message: (r && r.message) || '备注更新失败', type: 'error' })
               }
           } catch (e) {
               message({ message: '网络异常，稍后再试', type: 'error' })
           } finally {
               this.isModifyingAlias = false
           }
          },
        async cancelFavoriteByContext() {
          // 先抓取 appId，再隐藏菜单，避免被清空
          const appId = String(this.contextMenuTargetAppId || '').trim();
          this.hideContextMenu();
          if (!appId) return;
          const userRaw = localStorage.getItem('userInfo');
          if (!userRaw) {
            message({ message: '请先登录后再取消收藏', type: 'warning' });
            eventBus.emit && eventBus.emit('show-login');
            this.showLogin = true;
            return;
          }
          try {
            const userInfo = JSON.parse(userRaw);
            const arr = Array.isArray(userInfo.shoucang) ? userInfo.shoucang.map(x => String(x)) : [];
            const beforeLen = arr.length;
            const nextArr = arr.filter(id => id !== String(appId));
            if (nextArr.length === beforeLen) {
              message({ message: '该条目未在收藏中', type: 'info' });
              return;
            }
            userInfo.shoucang = nextArr;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            try {
              await axios.put(`${serverUrl}/api/user`, {
                userId: userInfo.userId,
                shoucang: userInfo.shoucang
              });
              message({ message: '已取消', type: 'success' });
            } catch (e) {
              console.warn('取消收藏同步失败:', e?.message || e);
            }
            eventBus.emit && eventBus.emit('cancel-favorite', String(appId));
          } catch (e) {
            console.error('取消收藏过程异常:', e);
            message({ message: '操作失败，请稍后重试', type: 'error' });
          }
        },
        // 举报用户
        async openReportDialog() {
            this.hideContextMenu();
            if (!this.userId) {
                message.warning('请先登录');
                this.showLoginModal();
                return;
            }
            // 优先使用上下文中的 peerId，其次通用 userId
            let targetId = this.contextMenuTargetPeerId || this.contextTargetUserId;
            
            // Check login first
            const token = localStorage.getItem('userToken');
            if (!token) {
                 message.warning('请先登录后操作');
                 this.showLoginModal();
                 return;
            }

            // 1. 尝试从路由参数获取 (ArticleDetails)
            if (!targetId) {
                targetId = this.$route.params.userId;
            }
            
            // 2. 尝试从右键菜单上下文获取
            if (!targetId || targetId === 'undefined') {
                 if (this.contextMenuTargetPeerId) {
                     targetId = this.contextMenuTargetPeerId;
                 } else if (this.contextTargetUserId) {
                     targetId = this.contextTargetUserId;
                 }
            }

            // 3. 最终尝试：如果只有用户名 (例如 @xxx)，尝试查找 ID
            if (!targetId && this.contextTargetUsername) {
                try {
                    const lookup = await userService.lookupUserIdByUsername(this.contextTargetUsername);
                    if (lookup && lookup.success && lookup.data && lookup.data.userId) {
                        targetId = String(lookup.data.userId);
                    }
                } catch (e) {
                   console.error('Lookup ID failed:', e);
                }
            }

            if (!targetId) {
                message.warning('无法获取目标用户ID');
                return;
            }

            // 禁止举报自己
            if (String(targetId) === String(this.userId)) {
                message.warning('不能举报自己');
                return;
            }

            this.reportTargetId = String(targetId);
            this.showReportModal = true;
        },
        async submitReport(targetId, reason) {
            try {
                this.isReporting = true;
                const token = localStorage.getItem('userToken');
                const response = await axios.post(`${serverUrl}/api/report`, {
                    targetId: String(targetId),
                    reason: String(reason)
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (response.data && response.data.success) {
                    message.success(response.data.message || '举报已提交');
                } else {
                    message.error(response.data.error || '举报提交失败');
                }
            } catch (error) {
                console.error('举报出错:', error);
                const status = error.response?.status;
                if (status === 401) {
                    message.error('身份验证失败，请重新登录');
                    this.showLoginModal();
                    return;
                }
                if (status === 403) {
                    message.error(error.response?.data?.error || '权限不足');
                    return;
                }
                const msg = error.response?.data?.error || '网络异常，举报失败';
                message.error(msg);
            } finally {
                this.isReporting = false;
            }
        },
        handleAvatarSuccess(url) {
            // Forward event via eventBus, useful for components like MyInfo that need to know
            eventBus.emit('avatar-uploaded', url);
        },
        async loadFollowModalData() {
            if (!this.currentFollowTargetUid) return;
            this.followModalLoading = true;
            try {
                const res = await followService.getList(this.currentFollowTargetUid, this.followModalType, this.followModalPage, this.followModalPageSize);
                if (res && res.success && res.data) {
                    this.followModalUsers = Array.isArray(res.data.details) ? res.data.details : [];
                    this.followModalTotal = res.data.total || 0;
                    
                    // Fetch avatars for users missing them
                    const needPopulate = this.followModalUsers.some(u => !u.avatarUrl);
                    if (needPopulate) {
                        try {
                            const env = process.env.NODE_ENV === 'development' ? 'development' : 'production';
                            await Promise.all(this.followModalUsers.map(async (u) => {
                                if (!u.avatarUrl) {
                                    const resp = await axios.get(`${serverUrl}/api/get-avatar-url`, { params: { username: u.username, env } });
                                    if (resp && resp.data && resp.data.success && resp.data.url) {
                                        u.avatarUrl = resp.data.url;
                                    }
                                }
                            }));
                        } catch (e) {
                            // Silently ignore avatar fetch errors
                        }
                    }
                }
            } catch (e) {
                console.error('Failed to load follow list', e);
            } finally {
                this.followModalLoading = false;
            }
        },
        async handleFollowPageChange(page) {
            this.followModalPage = page;
            await this.loadFollowModalData();
            // Scroll logic can be handled inside the modal via a ref if needed.
        },
        async handleUnfollow(targetUserId) {
             if (!this.currentFollowTargetUid || !targetUserId) return;
             try {
                const res = await followService.unfollow(this.currentFollowTargetUid, targetUserId);
                if (res && res.success) {
                    message.success('已取消关注');
                    this.followModalUsers = this.followModalUsers.filter(u => u.userId !== targetUserId);
                    this.followModalTotal = Math.max(0, this.followModalTotal - 1);
                    eventBus.emit('follow-list-change');
                } else {
                    message.error((res && res.message) || '取消关注失败');
                }
             } catch (e) {
                 message.error(e.message || '取消关注失败');
             }
        },
        handleFollowModalClose() {
             this.followModalUsers = [];
             this.followModalPage = 1;
             this.followModalTotal = 0;
        },
        async handleTwofaConfirm(totpCode) {
            try {
                const userData = localStorage.getItem('userInfo');
                if (!userData) {
                    message.error('用户未登录');
                    return;
                }
                const userInfo = JSON.parse(userData);
                
                const response = await axios.post(`${serverUrl}/api/user/twofa/confirm`, { 
                    userId: userInfo.userId, 
                    totpCode: totpCode 
                });
                
                if (response.data && response.data.success) {
                    message.success('两步验证已确认并生效');
                    this.twofaDialogVisible = false;
                    eventBus.emit('twofa-confirmed');
                } else {
                    message.error(response.data?.error || '确认失败');
                }
            } catch (error) {
                message.error(error?.response?.data?.error || '确认失败');
            }
        }
    },
    async mounted() {
            startHealthCheck()
            let lastServerDown = false
            this._unregisterHealthListener = onServerStatusChange((down) => {
                if (lastServerDown && !down) {
                    // 服务器从宕机状态恢复，刷新页面
                    window.location.reload()
                }
                lastServerDown = down
                this.serverDown = down
            })

            // 设置背景壁纸
            this.wallpapertoggle();
            this.wallpaperTimer = setInterval(this.wallpapertoggle, 60000);
            // 异步加载用户壁纸偏好并应用
            this.loadWallpaperPrefs().then(() => this.applyWallpaper());
            
            // 自动验证账号
            await this.autoVerifyAccount();
            
            // 检查公告显示
            setTimeout(() => {
                this.checkAnnouncement();
            }, 1000); // 延迟1秒显示，确保页面加载完成
            
            this.injectDynamicFonts();

            // 站外跳转链接全局拦截（覆盖 <a> 标签与全局 window.open）
            window.addEventListener('click', this.handleGlobalLinkClick, true);
            window.$openSafeUrl = (rawUrl, target = '_blank') => {
                this.openSafeUrl(rawUrl, target);
            };
            this.setupWindowOpenProxy();

        // 动态导入事件总线
        import('@/utils/eventBus').then(module => {
                const eventBus = module.default
                eventBus.on('open-safe-url', (payload) => {
                    if (!payload) return;
                    const url = typeof payload === 'string' ? payload : payload.url;
                    const target = (typeof payload === 'object' && payload.target) ? payload.target : '_blank';
                    this.openSafeUrl(url, target);
                });
                eventBus.on('show-login', () => {
                    this.showLoginModal()
                })
                eventBus.on('show-forgot-password', () => {
                    this.forgotPasswordModalVisible = true
                })
                eventBus.on('show-twofa-dialog', (payload) => {
                    this.twofaDialogSecret = payload.secret
                    this.twofaDialogOtpauth = payload.otpauth
                    this.twofaDialogVisible = true
                })
                eventBus.on('show-avatar-modal', (payload) => {
                    this.avatarModalUsername = payload.username
                    this.avatarModalVisible = true
                })
                eventBus.on('show-follow-modal', (payload) => {
                    this.followModalType = payload.type || 'following'
                    this.currentFollowTargetUid = payload.uid
                    this.followModalPage = 1
                    this.followModalVisible = true
                    this.loadFollowModalData()
                })
                
                // 迁移自 AppDetails.vue 的全局事件
                eventBus.on('open-share', (payload) => {
                    this.shareText = payload.text || ''
                    this.shareModalVisible = true
                })
                eventBus.on('open-agreement', (payload) => {
                    this.agreementConfirmCallback = payload.onConfirm
                    this.agreementModalVisible = true
                })
                eventBus.on('open-cloud-code', (payload) => {
                    this.currentCloudCode = payload.code || ''
                    this.cloudCodeConfirmCallback = payload.onConfirm
                    this.cloudCodeModalVisible = true
                })
                eventBus.on('open-github-download', (payload) => {
                    this.githubDownloadUrl = payload.url || ''
                    this.githubAppId = payload.appId || null
                    this.githubInitialFile = payload.directAsset || null
                    this.githubDownloadModalVisible = true
                })
                eventBus.on('open-urge-update', (payload) => {
                    this.urgeUpdateAppId = payload.appId || null
                    this.urgeUpdateDialogVisible = true
                })
                eventBus.on('open-report-user', (payload) => {
                    this.reportTargetId = payload.targetUserId || null
                    this.reportTargetUsername = payload.targetUsername || ''
                    this.showReportModal = true
                })
            })
            
            // 添加全局复制监听
            this.addCopyListener();
            
            // 监听服务器广播消息
            websocketService.on('serverMessage', (data) => {
                if (data && data.content) {
                    const title = data.category || '系统消息';
                    let msgContent = data.content;
                    
                    notification({
                        title: title,
                        message: msgContent,
                        type: 'info',
                        duration: 5000,
                        position: 'top-right'
                    });
                }
            });

            // 根据路由参数自动弹出登录或注册框
            if (this.$route?.query?.login === '1') {
                this.showLoginModal()
            } else if (this.$route?.query?.register === '1') {
                this.showRegisterModal()
            }
            this.$router.afterEach((to) => {
                if (to?.query?.login === '1') {
                    this.showLoginModal()
                } else if (to?.query?.register === '1') {
                    this.showRegisterModal()
                }
            })
            
            // 初始化设备检测
            const checkMobile = () => {
              const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
              const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
              this.isMobileDevice = isMobileUA || (hasTouch && window.innerWidth <= 768);
            };
            checkMobile();
            window.addEventListener('resize', checkMobile);
            
            // 添加全局右键菜单监听
            document.addEventListener('contextmenu', this.showContextMenu);
            
            // 添加全局双击事件监听（用于图片查看器）
            document.addEventListener('dblclick', this.handleImageDoubleClick);
            
            // 添加图片悬停事件监听
            document.addEventListener('mouseenter', this.handleImageMouseEnter, true);
            document.addEventListener('mouseleave', this.handleImageMouseLeave, true);
            document.addEventListener('mousemove', this.handleImageMouseMove);

            // 初始化用户与偏好，并订阅私信推送（等待好友映射加载完毕）
            await this.initUserAndPrefs()
            websocketService.on('privateMessage', this.handleIncomingMessage)
            eventBus.on('prefs-updated', this.onPrefsUpdated)
            eventBus.on('show-login-modal', this.showLoginModal)
            eventBus.on('show-announcement', this.showAnnouncementModal)
            eventBus.on('show-download', this.showGlobalDownload)
            eventBus.on('show-history', this.showGlobalHistory)
            eventBus.on('show-cloud-download', this.showGlobalCloudDownload)
            eventBus.on('show-feedback', this.showGlobalFeedback)
            eventBus.on('show-submission', this.showGlobalSubmission)
            eventBus.on('show-donation', this.showGlobalDonation)
            eventBus.on('show-friendlink-apply', this.showGlobalFriendLinkApply)
            eventBus.on('security-blocked', () => {
                this.securityBlocked = true
            })
            eventBus.on('wallpaper-changed', this.onWallpaperChanged)
            eventBus.on('auth-cleared', this.onAuthCleared)
    },
    beforeUnmount() {
        stopHealthCheck()
        if (this._unregisterHealthListener) {
            this._unregisterHealthListener()
        }
        // 清理全局链接点击监听器与代理
        window.removeEventListener('click', this.handleGlobalLinkClick, true);
        this.restoreWindowOpenProxy();
        // 清理复制事件监听器
        if (this.copyHandler) {
            document.removeEventListener('copy', this.copyHandler);
        }
        // 清理右键菜单事件监听器
        document.removeEventListener('contextmenu', this.showContextMenu);
        document.removeEventListener('click', this.hideContextMenu);
        // 清理双击事件监听器
        document.removeEventListener('dblclick', this.handleImageDoubleClick);
        // 清理图片悬停事件监听器
        document.removeEventListener('mouseenter', this.handleImageMouseEnter, true);
        document.removeEventListener('mouseleave', this.handleImageMouseLeave, true);
        document.removeEventListener('mousemove', this.handleImageMouseMove);
        // 清理图片悬停定时器
        if (this.imageTooltipTimer) {
            clearTimeout(this.imageTooltipTimer);
            this.imageTooltipTimer = null;
        }
        eventBus.off('prefs-updated', this.onPrefsUpdated)
        eventBus.off('show-login-modal', this.showLoginModal)
        eventBus.off('show-announcement', this.showAnnouncementModal)
        eventBus.off('show-download', this.showGlobalDownload)
        eventBus.off('show-history', this.showGlobalHistory)
        eventBus.off('show-cloud-download', this.showGlobalCloudDownload)
        eventBus.off('show-feedback', this.showGlobalFeedback)
        eventBus.off('show-submission', this.showGlobalSubmission)
        eventBus.off('show-donation', this.showGlobalDonation)
        eventBus.off('show-friendlink-apply', this.showGlobalFriendLinkApply)
        eventBus.off('security-blocked')
        eventBus.off('wallpaper-changed', this.onWallpaperChanged)
        eventBus.off('auth-cleared', this.onAuthCleared)
        // 清理壁纸切换定时器
        if (this.wallpaperTimer) {
          clearInterval(this.wallpaperTimer)
          this.wallpaperTimer = null
        }
        eventBus.off('show-avatar-modal')
        eventBus.off('show-follow-modal')
        websocketService.off('privateMessage', this.handleIncomingMessage)
    }
}
</script>

<style lang="less">
// 全局过渡动画
/* 移除全局瞬发过渡以解决背景闪烁问题 */
/* * {
    transition: background-color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                border-color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
} */

// 夜间模式全局样式
body {
    position: relative;
    overflow-x: hidden;
}

html.dark-theme,
body.dark-theme {
    position: relative;
    background-color: #121316 !important;
    color-scheme: dark;
}

// 移除夜间模式蒙层，解决菜单交互问题

.framework {
    margin: 0;
    padding: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    overflow-x: hidden;
    width: 100%;
    height: 100vh;
    transform: none;
    position: relative;
    // background-image: url('./assets/img/Abstract_Landscape_1.webp');
}

// 全局右键菜单样式
.global-context-menu {
    position: fixed;
    z-index: 999999 !important; /* 置顶层级，覆盖全站 Modal / Dialog 对话框 */
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
    min-width: 120px;
    padding: 4px 0;
    font-size: 14px;
    animation: contextMenuFadeIn 0.2s ease-out;

    .menu-item-text {
        display: inline-block;
    }
}

.context-menu-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    color: #606266;
    transition: background-color 0.2s ease, color 0.2s ease;
    user-select: none;
    
    i {
        margin-right: 8px;
        font-size: 16px;
    }
    
    &:hover {
        background: rgba(64, 158, 255, 0.1);
        color: #409eff;
    }
    
    &:active {
        background: rgba(64, 158, 255, 0.2);
    }
}

// 深色主题下的右键菜单样式
body.dark-theme .global-context-menu {
    background: rgba(48, 49, 51, 0.95);
    border-color: #4c4d4f;
    color: #e4e7ed;
}

body.dark-theme .context-menu-item {
    color: #e4e7ed;
    
    &:hover {
        background: rgba(64, 158, 255, 0.2);
        color: #409eff;
    }
}

// 移动端适配 (横向排列只留 logo 图标、超出可横向滚动，不溢出视口)
.global-context-menu.is-mobile-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 6px;
    min-width: auto;
    max-width: calc(100vw - 20px);
    box-sizing: border-box;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;

    &::-webkit-scrollbar {
        display: none;
    }

    .context-menu-item {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px 12px;
        border-radius: 18px;
        user-select: none;
        -webkit-user-select: none;
        
        i {
            margin-right: 0;
            font-size: 18px;
        }

        .menu-item-text {
            display: none;
        }
        
        &:active {
            background: rgba(64, 158, 255, 0.25);
            transform: scale(0.92);
        }
    }
}

@media (max-width: 768px) {
    .global-context-menu {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 4px 6px;
        min-width: auto;
        max-width: calc(100vw - 20px);
        box-sizing: border-box;
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.96);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        scrollbar-width: none;
        -ms-overflow-style: none;
        -webkit-overflow-scrolling: touch;
        touch-action: pan-x;

        &::-webkit-scrollbar {
            display: none;
        }

        .context-menu-item {
            flex: 0 0 auto;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 8px 12px;
            border-radius: 18px;
            user-select: none;
            -webkit-user-select: none;
            
            i {
                margin-right: 0;
                font-size: 18px;
            }

            .menu-item-text {
                display: none;
            }
            
            &:active {
                background: rgba(64, 158, 255, 0.25);
                transform: scale(0.92);
            }
        }
    }
}

body.dark-theme .global-context-menu.is-mobile-menu {
    background: rgba(40, 42, 45, 0.96) !important;
}

// 右键菜单动画
@keyframes contextMenuFadeIn {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-5px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

/* 图片悬停提示样式 */
.image-tooltip {
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: var(--z-dropdown);
  pointer-events: none;
  white-space: nowrap;
  animation: tooltipFadeIn 0.2s ease;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}


/* 添加好友对话框样式 */
.friend-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: var(--z-sticky);
  display: flex;
  align-items: center;
  justify-content: center;
}
.friend-dialog {
  width: 360px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  overflow: hidden;
}
.friend-dialog-header {
  padding: 12px 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #eee;
}
.friend-dialog-body {
  padding: 14px 16px;
}
.friend-dialog-target {
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
}
.friend-dialog-textarea {
  width: calc(100% - 16px);
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 8px;
  resize: vertical;
  font-size: 14px;
}
.friend-dialog-textarea::placeholder{
  font-family: '猫啃网糖圆体';
}
.friend-dialog-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 10px 16px 16px;
}
.friend-btn-cancel {
  padding: 8px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
}
.friend-btn-submit {
  padding: 8px 14px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

/* 过渡动画：淡入淡出 + 弹出缩放 */
.friend-dialog-enter-active,
.friend-dialog-leave-active {
  transition: opacity 0.2s ease;
}
.friend-dialog-enter-from,
.friend-dialog-leave-to {
  opacity: 0;
}
/* 内部弹窗的位移与缩放 */
.friend-dialog-enter-active .friend-dialog,
.friend-dialog-leave-active .friend-dialog {
  transition: transform 0.22s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease;
}
.friend-dialog-enter-from .friend-dialog {
  transform: translateY(12px) scale(0.98);
  opacity: 0;
}
.friend-dialog-enter-to .friend-dialog {
  transform: translateY(0) scale(1);
  opacity: 1;
}
.friend-dialog-leave-to .friend-dialog {
  transform: translateY(12px) scale(0.98);
  opacity: 0;
}

body.dark-theme .friend-dialog { background: #2f2f31; }
body.dark-theme .friend-dialog-header { color: #e4e7ed; border-color: #4c4d4f; }
body.dark-theme .friend-dialog-target { color: #c0c4cc; }
body.dark-theme .friend-dialog-textarea { background: #3a3a3c; color: #e4e7ed; border-color: #4c4d4f; }
body.dark-theme .friend-btn-cancel { background: #3a3a3c; color: #e4e7ed; border-color: #4c4d4f; }

/* ElMessageBox Dark Mode Support */
body.dark-theme .el-message-box {
  background-color: #2f2f31;
  border-color: #4c4d4f;
  --el-message-box-title-color: #e4e7ed;
  --el-text-color-primary: #e4e7ed;
  --el-text-color-regular: #c0c4cc; 
}
body.dark-theme .el-message-box__headerbtn .el-message-box__close {
  color: #909399;
}
body.dark-theme .el-message-box__headerbtn:hover .el-message-box__close {
  color: #409eff;
}

/* 全局页脚移动端隐藏，与LeftMenu的移动端断点768px保持一致 */
@media (max-width: 768px) {
  .global-footer {
    display: none !important;
  }
  .mobile-hidden-view {
    display: none !important;
  }
}

/* 修复移动端 Element Notification 溢出问题 */
@media (max-width: 480px) {
  .el-notification {
    width: auto !important;
    right: 16px !important;
    left: 16px !important;
    max-width: none !important;
    
    /* 移动端深色模式 */
    body.dark-theme & {
        background-color: #2f2f31 !important;
        border-color: #4c4d4f !important;
        
        .el-notification__title {
            color: #e4e7ed !important;
        }
        .el-notification__content {
            color: #c0c4cc !important;
        }
        .el-notification__closeBtn {
            color: #909399 !important;
        }
    }
  }
}

/* 全局 Notification & Message 层级提升，防止被对话框蒙层遮挡 */
.el-notification, .el-message {
  z-index: var(--z-toast) !important;
}

/* 全局 Notification 深色模式支持 */
body.dark-theme .el-notification {
  background-color: #2f2f31;
  border-color: #4c4d4f;
  
  .el-notification__title {
    color: #e4e7ed;
  }
  
  .el-notification__content {
    color: #c0c4cc;
  }
  
  .el-notification__closeBtn {
    color: #909399;
    
    &:hover {
      color: #909399;
    }
  }
}

/* 全局 ElMessage 深色模式支持 */
body.dark-theme .el-message {
  background-color: #2f2f31 !important;
  border-color: #4c4d4f !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4) !important;
  
  .el-message__content {
    color: #e4e7ed !important;
  }
}

/* 🧪 UI 测试实验室样式 */
.ui-test-trigger {
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: var(--z-floating);
  background: linear-gradient(135deg, #FF9500 0%, #FF2D55 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 40px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(255, 45, 85, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  font-family: '爱点风雅黑', sans-serif;
}

.ui-test-trigger:hover {
  transform: scale(1.1) translateY(-5px);
  box-shadow: 0 15px 40px rgba(255, 45, 85, 0.5);
}

.ui-test-lab {
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: var(--z-overlay);
  width: 320px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);
  padding: 24px;
  animation: slideInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

@media (max-width: 768px) {
  .ui-test-lab {
    width: calc(100% - 32px);
    bottom: 0;
    right: 0;
    left: 0;
    border-radius: 24px 24px 0 0;
    max-height: 70vh;
    padding: 20px 16px 40px;
  }
}

.dark-theme .ui-test-lab {
  background: rgba(40, 40, 42, 0.85);
  border-color: rgba(255, 255, 255, 0.15);
}

.test-lab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.test-lab-header span {
  font-weight: 800;
  font-size: 18px;
  color: #1d1d1f;
}

.dark-theme .test-lab-header span { color: #f5f5f7; }

.test-lab-header button {
  background: none;
  border: none;
  color: #8e8e93;
  cursor: pointer;
  font-size: 18px;
  transition: color 0.2s;
}

.test-lab-header button:hover { color: #ff4d4f; }

.test-lab-divider {
  width: 100%;
  padding: 15px 0 8px;
  font-size: 11px;
  font-weight: 800;
  color: #007aff;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  background: linear-gradient(to right, rgba(0, 122, 255, 0.1), transparent);
  margin: 10px 0;
  padding-left: 10px;
  border-radius: 4px;
}

.test-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  overflow-y: auto;
  padding-right: 5px;
}

.test-buttons::-webkit-scrollbar {
  width: 4px;
}

.test-buttons::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.test-buttons button {
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.6);
  color: #1d1d1f;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
}

.dark-theme .test-buttons button {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.08);
  color: #f5f5f7;
}

.test-buttons button:hover {
  background: #007aff;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.2);
}

.dark-theme .test-buttons button:hover {
  background: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(30px) scale(0.9); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 480px) {
  .ui-test-trigger {
    bottom: 20px;
    right: 20px;
    padding: 10px 16px;
    font-size: 14px;
  }
  .ui-test-lab {
    bottom: 0;
    right: 0;
    width: calc(100% - 32px);
    border-radius: 30px 30px 0 0;
  }
}
</style>